const publications = [
    {
        date: '04/2024',
        title: 'Applying Machine Learning Techniques to Bioinformatics: Few-Shot and Zero-Shot Methods',
        contributors: 'U. K. Lilhore, A. Kumar, S. Simaiya, N. Vyas, and V. Dutt, Eds.',
        type: 'Book',
        publisher: 'IGI Global',
        doi: '10.4018/979-8-3693-1822-5',
        doiText: '10.4018/979-8-3693-1822-5',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.4018/979-8-3693-1822-5'
    },
    {
        date: '11/2023',
        title: 'Innovations in Machine Learning and IoT for Water Management',
        contributors: 'A. Kumar, A. L. Srivastav, A. K. Dubey, V. Dutt, and N. Vyas, Eds.',
        type: 'Book',
        publisher: 'IGI Global',
        doi: '10.4018/979-8-3693-1194-3',
        doiText: '10.4018/979-8-3693-1194-3',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.4018/979-8-3693-1194-3'
    },
    {
        date: '12/2023',
        title: 'Quantum Innovations at the Nexus of Biomedical Intelligence',
        contributors: 'V. Dutt, A. Kumar, S. Ahuja, A. Baliyan, and N. Vyas, Eds.',
        type: 'Book',
        publisher: 'IGI Global',
        doi: '10.4018/979-8-3693-1479-1',
        doiText: '10.4018/979-8-3693-1479-1',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.4018/979-8-3693-1479-1'
    },
    {
        date: '03/2024',
        title: 'Elevating IoT Sensor Data Management and Security Through Blockchain Solutions',
        contributors: 'N. Bhati and N. Vyas',
        type: 'Book Chapter',
        publisher: 'IGI Global',
        doi: '10.4018/979-8-3693-0968-1.ch003',
        doiText: '10.4018/979-8-3693-0968-1.ch003',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://www.igi-global.com/chapter/elevating-iot-sensor-data-management-and-security-through-blockchain-solutions/342145'
    },
    {
        date: '05/2024',
        title: 'Advanced Real-Time Simulation Framework for the Physical Interaction Dynamics of Production Lines Leveraging Digital Twin Paradigms',
        contributors: 'N. Bhati, N. Vyas, V. Dutt, R. Duggar, and A. Pokhriyal',
        type: 'Book Chapter',
        publisher: 'Wiley',
        doi: '10.1002/9781394257003.ch15',
        doiText: '10.1002/9781394257003.ch15',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://onlinelibrary.wiley.com/doi/10.1002/9781394257003.ch15'
    },
    {
        date: '11/2023',
        title: 'Advancing Precision Agriculture: Leveraging YOLOv8 for Robust Deep Learning Enabled Crop Diseases Detection',
        contributors: 'N. Vyas and V. Dutt',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Integration of Computational Intelligent System (ICICIS), Pune, India, 2023, pp. 1-6',
        doi: '10.1109/ICICIS56802.2023.10430280',
        doiText: '10.1109/ICICIS56802.2023.10430280',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICICIS56802.2023.10430280'
    },
    {
        date: '11/2023',
        title: 'Genetic Algorithm-Driven Hyperparameter Optimization of Capsule Networks for Predictive Analysis of Genetic Mutations',
        contributors: 'N. Vyas, V. C. Patil, V. Desai Jabbar and Anurag',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 Seventh International Conference on Image Information Processing (ICIIP), Solan, India, 2023, pp. 616-621',
        doi: '10.1109/ICIIP61524.2023.10537665',
        doiText: '10.1109/ICIIP61524.2023.10537665',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICIIP61524.2023.10537665'
    },
    {
        date: '11/2023',
        title: 'Hybrid Convolutional-Recurrent Neural Network Architecture with Attention Mechanisms for Multi-modal Medical Image Segmentation',
        contributors: 'N. Vyas, A. Gudur, A. I. Tamboli and Anurag',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 Seventh International Conference on Image Information Processing (ICIIP), Solan, India, 2023, pp. 622-627',
        doi: '10.1109/ICIIP61524.2023.10537765',
        doiText: '10.1109/ICIIP61524.2023.10537765',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICIIP61524.2023.10537765'
    },
    {
        date: '11/2023',
        title: 'Distributed Deep Reinforcement Learning with Graph Neural Networks for Personalized Drug Interaction Analysis',
        contributors: 'N. Vyas, N. N. Jadhav, V. V. Raje and C. Choudhary',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 Seventh International Conference on Image Information Processing (ICIIP), Solan, India, 2023, pp. 610-615',
        doi: '10.1109/ICIIP61524.2023.10537643',
        doiText: '10.1109/ICIIP61524.2023.10537643',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICIIP61524.2023.10537643'
    },
    {
        date: '11/2023',
        title: 'Exploring the Critical Role of Edge Computing in Enhancing IoT Performance and Security',
        contributors: 'Anurag, C. Choudhary and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Communication, Security and Artificial Intelligence (ICCSAI), Greater Noida, India, 2023, pp. 563-568',
        doi: '10.1109/ICCSAI59793.2023.10421138',
        doiText: '10.1109/ICCSAI59793.2023.10421138',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICCSAI59793.2023.10421138'
    },
    {
        date: '11/2023',
        title: 'An Optimized Sign Language Recognition using Convolutional Neural Networks (CNNs) and TensorFlow',
        contributors: 'C. Choudhary, N. Vyas and U. K. Lilhore',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Technological Advancements in Computational Sciences (ICTACS), Tashkent, Uzbekistan, 2023, pp. 896-901',
        doi: '10.1109/ICTACS59847.2023.10390276',
        doiText: '10.1109/ICTACS59847.2023.10390276',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICTACS59847.2023.10390276'
    },
    {
        date: '11/2023',
        title: 'Detecting Seizures from EEG Data: The Potential of Deep Learning Techniques',
        contributors: 'Mamta, M. B. Mane, N. Vyas and A. Baliyan',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Technological Advancements in Computational Sciences (ICTACS), Tashkent, Uzbekistan, 2023, pp. 439-444',
        doi: '10.1109/ICTACS59847.2023.10390369',
        doiText: '10.1109/ICTACS59847.2023.10390369',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICTACS59847.2023.10390369'
    },
    {
        date: '11/2023',
        title: 'Cloud Security: Challenges and Strategies for Ensuring Data Protection',
        contributors: 'C. Choudhary, N. Vyas and U. Kumar Lilhore',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Technological Advancements in Computational Sciences (ICTACS), Tashkent, Uzbekistan, 2023, pp. 669-673',
        doi: '10.1109/ICTACS59847.2023.10390302',
        doiText: '10.1109/ICTACS59847.2023.10390302',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICTACS59847.2023.10390302'
    },
    {
        date: '11/2023',
        title: 'The Impact of Air Pollution on Respiratory Health Results: An Analysis of Asthma and COPD in a Population Study',
        contributors: 'N. Vyas, P. A. P., P. Das and Y. Mahajan',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Computing, Communication, and Intelligent Systems (ICCCIS), Greater Noida, India, 2023, pp. 141-146',
        doi: '10.1109/ICCCIS60361.2023.10425187',
        doiText: '10.1109/ICCCIS60361.2023.10425187',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICCCIS60361.2023.10425187'
    },
    {
        date: '11/2023',
        title: 'Transforming Work: The Impact of Artificial Intelligence (AI) On Modern Workplace',
        contributors: 'Anurag, N. Vyas and U. Kumar Lilhore',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Technological Advancements in Computational Sciences (ICTACS), Tashkent, Uzbekistan, 2023, pp. 602-607',
        doi: '10.1109/ICTACS59847.2023.10390258',
        doiText: '10.1109/ICTACS59847.2023.10390258',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICTACS59847.2023.10390258'
    },
    {
        date: '10/2023',
        title: 'Deepfake Detection Using CNN And DCGANS To Drop-Out Fake Multimedia Content: A Hybrid Approach',
        contributors: 'K. Bansal, S. Agarwal and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on IoT, Communication and Automation Technology (ICICAT), Gorakhpur, India, 2023, pp. 1-6',
        doi: '10.1109/ICICAT57735.2023.10263628',
        doiText: '10.1109/ICICAT57735.2023.10263628',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICICAT57735.2023.10263628'
    },
    {
        date: '10/2023',
        title: 'Personalized Cardiovascular Disease Risk Prediction using Random Forest: An Optimized Approach',
        contributors: 'V. R. Burugadda, V. Dutt, Mamta and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 IEEE World Conference on Applied Intelligence and Computing (AIC), Sonbhadra, India, 2023, pp. 226-232',
        doi: '10.1109/AIC57670.2023.10263915',
        doiText: '10.1109/AIC57670.2023.10263915',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/AIC57670.2023.10263915'
    },
    {
        date: '09/2023',
        title: 'Real-Time Traffic Analysis and Driver Safety Enhancement via IoT and Computer Vision with High-Resolution Project Lamps for Intelligent Road Illumination',
        contributors: 'H. Dhiman, N. Vyas, A. Pagrotra and V. Dutt',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Circuits, Power and Intelligent Systems (CCPIS), Bhubaneswar, India, 2023, pp. 01-06',
        doi: '10.1109/CCPIS59145.2023.10291872',
        doiText: '10.1109/CCPIS59145.2023.10291872',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/CCPIS59145.2023.10291872'
    },
    {
        date: '09/2023',
        title: 'Artificial Intelligence Based Fire and Smoke Detection and Security Control System',
        contributors: 'H. Prasad, A. Singh, J. Thakur, C. Choudhary and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Network, Multimedia and Information Technology (NMITCON), Bengaluru, India, 2023, pp. 01-06',
        doi: '10.1109/NMITCON58196.2023.10276198',
        doiText: '10.1109/NMITCON58196.2023.10276198',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/NMITCON58196.2023.10276198'
    },
    {
        date: '09/2023',
        title: 'Healthcare in the Aftermath of COVID-19: Charting a Course for the Future',
        contributors: 'B. Sharma and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Circuit Power and Computing Technologies (ICCPCT), Kollam, India, 2023, pp. 1280-1285',
        doi: '10.1109/ICCPCT58313.2023.10244828',
        doiText: '10.1109/ICCPCT58313.2023.10244828',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICCPCT58313.2023.10244828'
    },
    {
        date: '09/2023',
        title: 'Deep Learning-Based Automatic Face Expression Recognition Framework',
        contributors: 'Akanksha, K. Ranjan and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Circuit Power and Computing Technologies (ICCPCT), Kollam, India, 2023, pp. 1291-1296',
        doi: '10.1109/ICCPCT58313.2023.10245885',
        doiText: '10.1109/ICCPCT58313.2023.10245885',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICCPCT58313.2023.10245885'
    },
    {
        date: '09/2023',
        title: 'Multimodal Neuroimaging Data in Early Detection of Alzheimer’s Disease - Exploring the Role of Ensemble Models and GAN Algorithm',
        contributors: 'U. S. Sekhar, N. Vyas, V. Dutt and A. Kumar',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Circuit Power and Computing Technologies (ICCPCT), Kollam, India, 2023, pp. 1664-1669',
        doi: '10.1109/ICCPCT58313.2023.10245177',
        doiText: '10.1109/ICCPCT58313.2023.10245177',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICCPCT58313.2023.10245177'
    },
    {
        date: '09/2023',
        title: 'Enhancing Breast Cancer Diagnosis: A Deep Belief Network Approach for Mammography Image Analysis',
        contributors: 'V. R. Burugadda, V. C. Patil, N. Vyas and A. Pokhriyal',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Advances in Computation, Communication and Information Technology (ICAICCIT), Faridabad, India, 2023, pp. 46-51',
        doi: '10.1109/ICAICCIT60255.2023.10465784',
        doiText: '10.1109/ICAICCIT60255.2023.10465784',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICAICCIT60255.2023.10465784'
    },
    {
        date: '09/2023',
        title: 'A Machine Learning Framework for Accurate Prediction of Parkinson’s Disease from Speech Data',
        contributors: 'S. R. Burri, D. K. Agarwal, N. Vyas and R. Duggar',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Innovative Sustainable Computational Technologies (CISCT), Dehradun, India, 2023, pp. 1-6',
        doi: '10.1109/CISCT57197.2023.10351422',
        doiText: '10.1109/CISCT57197.2023.10351422',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/CISCT57197.2023.10351422'
    },
    {
        date: '09/2023',
        title: 'Chronic Kidney Disease Prediction Using Robust Approach in Machine Learning',
        contributors: 'Anurag, N. Vyas, V. Sharma and D. Balla',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Innovative Sustainable Computational Technologies (CISCT), Dehradun, India, 2023, pp. 1-5',
        doi: '10.1109/CISCT57197.2023.10351277',
        doiText: '10.1109/CISCT57197.2023.10351277',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/CISCT57197.2023.10351277'
    },
    {
        date: '08/2023',
        title: 'Exploring the Potential of Deep Reinforcement Learning for Autonomous Navigation in Complex Environments',
        contributors: 'V. R. Burugadda, N. Jadhav, N. Vyas and R. Duggar',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 7th International Conference On Computing, Communication, Control And Automation (ICCUBEA), Pune, India, 2023, pp. 1-6',
        doi: '10.1109/ICCUBEA58933.2023.10392109',
        doiText: '10.1109/ICCUBEA58933.2023.10392109',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICCUBEA58933.2023.10392109'
    },
    {
        date: '08/2023',
        title: 'Enhancing Land-Based Robotics through the Development of Remotely Operated Vehicles for Military, Rescue and Industrial Applications',
        contributors: 'V. R. Burugadda, N. Vyas and A. Pagrotra',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 3rd Asian Conference on Innovation in Technology (ASIANCON), Ravet IN, India, 2023, pp. 1-6',
        doi: '10.1109/ASIANCON58793.2023.10270756',
        doiText: '10.1109/ASIANCON58793.2023.10270756',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ASIANCON58793.2023.10270756'
    },
    {
        date: '07/2023',
        title: 'Optimizing Irrigation Efficiency with IoT and Machine Learning: A Transfer Learning Approach for Accurate Soil Moisture Prediction',
        contributors: 'S. R. Burri, D. K. Agarwal, N. Vyas and R. Duggar',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 World Conference on Communication & Computing (WCONF), Raipur, India, 2023, pp. 1-6',
        doi: '10.1109/WCONF58270.2023.10235220',
        doiText: '10.1109/WCONF58270.2023.10235220',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/WCONF58270.2023.10235220'
    },
    {
        date: '07/2023',
        title: 'The Convergence Of Cutting-Edge Technologies: Leveraging AI and Edge Computing to Transform the Internet of Medical Things (IoMT)',
        contributors: 'R. Punugoti, N. Vyas, A. T. Siddiqui and A. Basit',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 4th International Conference on Electronics and Sustainable Communication Systems (ICESC), Coimbatore, India, 2023, pp. 600-606',
        doi: '10.1109/ICESC57686.2023.10193047',
        doiText: '10.1109/ICESC57686.2023.10193047',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICESC57686.2023.10193047'
    },
    {
        date: '05/2023',
        title: 'A Novel Approach for Anomaly Detection in the Time-Series Data using Generative Adversarial Networks',
        contributors: 'R. Raturi, A. Kumar, N. Vyas and V. Dutt',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Sustainable Computing and Smart Systems (ICSCSS), Coimbatore, India, 2023, pp. 1352-1357',
        doi: '10.1109/ICSCSS57650.2023.10169365',
        doiText: '10.1109/ICSCSS57650.2023.10169365',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICSCSS57650.2023.10169365'
    },
    {
        date: '02/2023',
        title: 'Fuzzy KNN Implementation for Early Parkinson’s Disease Prediction',
        contributors: 'S. Chandrasekaran, V. Dutt, N. Vyas and A. Anand',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 7th International Conference on Computing Methodologies and Communication (ICCMC), Erode, India, 2023, pp. 896-901',
        doi: '10.1109/ICCMC56507.2023.10083522',
        doiText: '10.1109/ICCMC56507.2023.10083522',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/ICCMC56507.2023.10083522'
    },
    {
        date: '01/2023',
        title: 'Improved Healthcare System with Quantum Computing',
        contributors: 'S. Chandrasekaran, R. Agrawal, V. Dutt, and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Artificial Intelligence and Smart Communication (AISC). IEEE, Jan. 27, 2023',
        doi: '10.1109/aisc56616.2023.10085380',
        doiText: '10.1109/aisc56616.2023.10085380',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/aisc56616.2023.10085380'
    },
    {
        date: '01/2023',
        title: 'Student Sentiment Analysis Using Various Machine Learning Techniques',
        contributors: 'S. Chandrasekaran, V. Dutt, N. Vyas, and R. Kumar',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2023 International Conference on Artificial Intelligence and Smart Communication (AISC). IEEE, Jan. 27, 2023',
        doi: '10.1109/aisc56616.2023.10085018',
        doiText: '10.1109/aisc56616.2023.10085018',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/aisc56616.2023.10085018'
    },
    {
        date: '09/2022',
        title: 'RFID Based Attendance Monitoring System Using ESP8266 Wi-Fi Module and IoT Enabled Mobile Application',
        contributors: 'H. Krishna and N. Vyas',
        type: 'Journal',
        venue: 'Neural Computing and Applications, vol. 34, no. 9, pp. 2907-2916, 2022',
        doi: '10.14704/nq.2022.20.9.NQ44681',
        doiText: '10.14704/nq.2022.20.9.NQ44681',
        scopusIndexed: false,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.14704/nq.2022.20.9.NQ44681'
    },
    {
        date: '12/2020',
        title: 'Big Data Approach for Medical Data Classification: A Review Study',
        contributors: 'S. Boyapati, S. R. Swarna, V. Dutt, and N. Vyas',
        type: 'Conference',
        publisher: 'IEEE',
        venue: '2020 International Conference on Intelligent Sustainable Systems (ICISS). IEEE, Dec. 03, 2020',
        doi: '10.1109/iciss49785.2020.9315870',
        doiText: '10.1109/iciss49785.2020.9315870',
        scopusIndexed: true,
        wosIndexed: false,
        link: 'https://dx.doi.org/10.1109/iciss49785.2020.9315870'
    }
];

export default publications;
